export function getSubdomainFromUrl(_urlOrHostname = null, options = {}) {

    let urlOrHostname = ''

    if (!_urlOrHostname || typeof _urlOrHostname !== 'string') {
        urlOrHostname = window.location.hostname
    } else {
        urlOrHostname = _urlOrHostname
    }

    const opts = Object.assign({
        ignoreWWW: true,

        publicSuffixes: [
            'co.uk', 'org.uk', 'gov.uk', 'ac.uk', 'com.au', 'net.au', 'co.nz', 'co.jp',
            'id.ir', 'co.ir', 'net.ir', 'gov.ir', 'co.ir', 'sch.ir', 'ac.ir', 'org.ir',
            'aaa.pro', 'ac.vn', 'aca.pro', 'acct.pro', 'avocat.pro', 'bar.pro', 'co.ag', 'co.in', 'co.lc',
            'com.ag', 'com.co', 'com.lc', 'com.tw', 'com.vc', 'cpa.pro', 'edu.vn', 'eng.pro', 'firm.in',
            'co.uk', 'gen.in', 'gov.vn', 'health.vn', 'ind.in', 'info.vn', 'int.vn', 'jur.pro', 'l.lc',
            'law.pro', 'ltd.uk', 'me.uk', 'med.pro', 'name.vn', 'net.ag', 'net.co', 'net.in', 'net.lc',
            'net.tw', 'net.uk', 'net.vc', 'net.vn', 'nom.ag', 'nom.co', 'org.ag', 'org.in', 'org.lc',
            'org.tw', 'org.uk', 'org.vc', 'org.vn', 'p.lc', 'plc.uk', 'pro.vn', 'recht.pro'
        ]
    }, options);


    // استخراج hostname
    let hostname;
    try {
        hostname = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(urlOrHostname)
            ? new URL(urlOrHostname).hostname
            : urlOrHostname;
    } catch {
        hostname = urlOrHostname;
    }

    if (!hostname || typeof hostname !== 'string') return null;
    hostname = hostname.toLowerCase().trim();

    // حذف حالت‌های خاص
    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname) || hostname.startsWith('[')) {
        return null;
    }

    const parts = hostname.split('.');
    if (parts.length < 2) return null;

    // بررسی پسوند چندبخشی
    let publicSuffix = null;
    for (const s of opts.publicSuffixes) {
        if (hostname.endsWith('.' + s)) {
            publicSuffix = s;
            break;
        }
    }

    let domainPartsCount = publicSuffix
        ? publicSuffix.split('.').length + 1 // مثل example.co.uk → 1 دامنه + 2 suffix = 3
        : 2; // معمولی: domain + tld

    if (parts.length <= domainPartsCount) return null;

    const subdomain = parts[0]; // فقط اولین بخش زیردامنه
    if (opts.ignoreWWW && subdomain === 'www') return null;

    return subdomain;
}


